export default [
  // Список заявок
  {
    header: 'sidebar.list_of_applications',
    permission: ['admin', 'chief_manager', 'manager', 'builder', 'foreman', 'supplier', 'chief_supplier'],
  },
  {
    title: 'sidebar.material',
    icon: 'SlackIcon',
    route: 'applications-material',
    permission: ['admin', 'chief_manager', 'builder', 'manager', 'foreman'],
    // tag: '1',
  },
  {
    title: 'sidebar.instrument',
    icon: 'TagIcon',
    route: 'applications-instrument',
    permission: ['admin', 'chief_manager', 'builder', 'manager', 'foreman']
  },
  {
    title: 'write-offs',
    icon: 'ShuffleIcon',
    route: 'write-offs',
    permission: ['admin', 'builder']
  },
  {
    title: 'sidebar.movement',
    icon: 'FileIcon',
    route: 'moving',
    permission: ['admin', 'chief_manager', 'manager', 'foreman']
  },
  {
    title: 'sidebar.for_purchase',
    icon: 'BriefcaseIcon',
    route: 'for-sale',
    permission: ['admin', 'supplier', 'chief_supplier']
  },
  {
    title: 'transport',
    icon: 'TruckIcon',
    route: 'applications-transport',
    permission: ['admin', 'builder', 'foreman', 'supplier', 'chief_supplier', 'supervisor', 'financier']
  },
  {
    title: 'sidebar.for_return',
    icon: 'CornerUpLeftIcon',
    route: 'return',
    permission: ['admin', 'chief_manager', 'manager']
  },
  {
    title: 'application_for_works',
    icon: 'BookIcon',
    route: 'applications-works',
    permission: ['admin', 'chief_manager', 'manager', 'supervisor', 'accountant', 'financier']
  },
  
]
